import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { isValidToken } from '../../utils/jwt';

const initialState = {
  isLoading: false,
  error: false,
  olas: [],
  admin: [],
  user: []
};

const slice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getOlasSuccess(state, action) {
      state.isLoading = false;
      state.olas = action.payload;
    },

    getGraficasAdminSuccess(state, action) {
      state.isLoading = false;
      state.admin = action.payload;
    },

    getGraficasUsuarioSuccess(state, action) {
      state.isLoading = false;
      state.user = action.payload;
    }
  }
});

export default slice.reducer;

export function getOlas() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      if (accessToken && isValidToken(accessToken)) {
        const response = await axios.get('/dashboard/obtener-olas');
        dispatch(slice.actions.getOlasSuccess(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getGraficasAdmin(request) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      if (accessToken && isValidToken(accessToken)) {
        const response = await axios.get('/dashboard/graficas-admin', {
          params: request
        });
        dispatch(slice.actions.getGraficasAdminSuccess(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getGraficasUser(request) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      if (accessToken && isValidToken(accessToken)) {
        const response = await axios.get('/dashboard/graficas-usuario', {
          params: request
        });
        dispatch(slice.actions.getGraficasUsuarioSuccess(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
